import React from "react";
import Dialog from "@material-ui/core/Dialog";
import FileUploader from "../../../common/fileUploader/fileUploader.js";
import FileDownload from "../../../common/fileDownload/fileDownload.js";
import whitelistedEmailsList from "./whitelistedEmailsForOperations.json";

export default class ResponsiveDialog extends React.Component {
    state = {
        open: false
    };

    handleClickOpen = () => {
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {

        let restrictmailids = JSON.parse(localStorage.getItem("user"));
        let jumbotailUser = restrictmailids.userProfile.loginId.split('@');
        let loggedInUser = JSON.parse(localStorage.getItem("user"));
        let tenant_Id = restrictmailids.userProfile.tenantId;

        return (
            <div style={{display: 'flow-root'}}>
                {
                    tenant_Id == "TENANT-135108" && !whitelistedEmailsList["emailIds"].includes(loggedInUser.userProfile.loginId)
                    ?
                    " "
                    :
                    (
                        <button onClick={this.handleClickOpen} className="btn btn-jt-ops pull-right">
                            + Create New Credit Line
                        </button>
                    )
                }

                <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="responsive-dialog-title"
                        maxWidth="lg" classes={{paperWidthSm: 'wider-dialoge'}}>
                    <div>
                        <div style={{padding: "20px"}}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="pull-right" onClick={this.handleClose}
                                         style={{fontSize: "22px", cursor: "pointer"}}>
                                        <i className="fas fa-times"/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="ingestionTitle">Add Credit Line</div>
                                    <div className="formattor">
                                        <FileDownload title={"Download Format"}
                                                      url="api/credit/gateway/template/ingest/credit_lines"/>
                                    </div>
                                    <FileUploader url="api/credit/gateway/ingest/credit_line/bulk"/>
                                </div>
                                <div className="col-md-4">
                                    <div className="ingestionTitle">Business Id Encryption</div>
                                    <div className="formattor">
                                        <FileDownload title={"Download Format"}
                                                      url="api/credit/gateway/template/ingest/encrypt"/>
                                    </div>
                                    <FileUploader url="api/credit/gateway/ingest/encrypt/bulk"/>
                                </div>
                                <div className="col-md-4">
                                    <div className="ingestionTitle">Differential Credit Details</div>
                                    <div className="row">
                                        <div className="formattor col-md-6">
                                            <FileDownload title={"Format"}
                                                          url="api/credit/gateway/template/ingest/differential_credit_details"/>
                                        </div>
                                        <div className="formattor col-md-6">
                                            <FileDownload title={"Dump"}
                                                          url="api/credit/gateway/dump/differential_credit_details"/>
                                        </div>
                                    </div>
                                    <FileUploader url="api/credit/gateway/ingest/differential_credit_details/bulk"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/customerCreditDetails/components/CreditLinesIngestionBox.js